import Collapsible from '../shared/Collapsible.js';
import {usePersistentViewState} from '../lib/usePersistentViewState.js';
import '../broiler/poultryDesign.css';
import React from 'react';
import {useAppLocation} from '../app/navigation/index.js';
import type {AuthState} from '../contexts/AuthContext.js';
import type {SupabaseClient} from '../lib/supabaseTypes.js';
import RecordCollaborationSection from '../shared/RecordCollaborationSection.tsx';

type RetirementHomeHistoryProps = {
  sb: SupabaseClient;
  authState: AuthState;
  housings: readonly {id: string; housing_name?: string | null; notes?: string | null}[];
};

export default function RetirementHomeHistory({sb, authState, housings}: RetirementHomeHistoryProps) {
  const location = useAppLocation();
  const hasCommentLink = location.hash.startsWith('#comment-');
  const [open, setOpen] = usePersistentViewState('layer.retirement.history', hasCommentLink);

  React.useEffect(() => {
    if (hasCommentLink) setOpen(true);
  }, [hasCommentLink, location.hash]);

  if (housings.length === 0) return null;

  return (
    <div data-retirement-home-history="1" style={{marginTop: 16}}>
      <Collapsible label="Earlier Comments and Activity" open={open} onOpenChange={setOpen}>
        {open &&
          housings.map((housing) => (
            <div key={housing.id} style={{marginTop: 12}}>
              {housings.length > 1 && (
                <div style={{fontSize: 13, fontWeight: 600, color: 'var(--ink)'}}>
                  {housing.housing_name || 'Retirement Home'}
                </div>
              )}
              {housing.notes && (
                <div style={{fontSize: 13, color: 'var(--ink-muted)', whiteSpace: 'pre-wrap'}}>{housing.notes}</div>
              )}
              <RecordCollaborationSection
                sb={sb}
                authState={authState}
                entityType="layer.housing"
                entityId={housing.id}
                entityLabel={housing.housing_name || 'Retirement Home'}
              />
            </div>
          ))}
      </Collapsible>
    </div>
  );
}
